module.exports = __webpack_public_path__ + "static/media/3.dfcfe67a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/3.png
// module id = 883
// module chunks = 0